import React, { memo } from 'react'
import { Box, Typography, Paper, useTheme, useMediaQuery, Button } from '@mui/material'
import { connect } from 'react-redux'
import setRedirectUrl from '../../../redux/actions/redirection/setRedirectUrl'
import { useNavigate } from 'react-router-dom'

interface CardProps {
  descripcion: React.ReactNode
  logo: React.ReactElement
  botonVer?: string
  botonPath?: string
}

const CardEstadistica: React.FC<CardProps> = ({ descripcion, logo, botonVer, botonPath }: CardProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '16px 20px',
        gap: '16px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e0e0e0',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        transition: 'box-shadow 0.2s ease',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
          flexShrink: 0
        }}
      >
        {logo}
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          minWidth: 0
        }}
      >
        {descripcion}
      </Box>

      {botonVer && (
        <Button
          size="small"
          variant="contained"
          sx={{
            borderRadius: '8px',
            padding: '6px 16px',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: isMobile ? '14px' : '15px',
            flexShrink: 0,
            whiteSpace: 'nowrap'
          }}
          onClick={() => botonPath && navigate(`/${botonPath}`)}
        >
          {botonVer}
        </Button>
      )}
    </Paper>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  setRedirectUrl
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(CardEstadistica))
